import { NgModule } from '@angular/core';
import {
  MatButtonModule,
  MatIconModule,
  MatInputModule,
  MatNativeDateModule,
  MatSidenavModule,
  MatMenuModule,
  MatCheckboxModule,
  MatAutocompleteModule,
  MatTooltipModule,
  MatTabsModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSelectModule,
  MatToolbarModule,
  MatListModule,
  MatDialogModule,
  MatDatepickerModule,
  MatRadioModule,
  MatTableModule,
  MatPaginatorModule,
  MatExpansionModule,
  MatSortModule,
  MatFormFieldModule,
  MatChipsModule,
  MatCardModule,
  MatProgressBarModule, MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS, MatButtonToggleModule
} from '@angular/material';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { isMobile } from '../../../core/utils/utils';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';

// export const MY_FORMATS = {
//   parse: {
//     dateInput: 'DD.MM.YYYY',
//   },
//   display: {
//     dateInput: 'DD.MM.YYYY',
//     monthYearLabel: 'MM YYYY',
//     dateA11yLabel: 'DD.MM.YYYY',
//     monthYearA11yLabel: 'MM YYYY',
//   },
// };

const MaterialModules = [
  MatIconModule,
  MatInputModule,
  MatSidenavModule,
  MatButtonModule,
  MatNativeDateModule,
  MatMenuModule,
  MatCheckboxModule,
  MatAutocompleteModule,
  MatTooltipModule,
  MatTabsModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSelectModule,
  MatToolbarModule,
  MatDialogModule,
  MatListModule,
  MatDatepickerModule,
  MatRadioModule,
  MatTableModule,
  MatPaginatorModule,
  MatExpansionModule,
  MatSortModule,
  MatFormFieldModule,
  MatChipsModule,
  MatProgressBarModule,
  MatCardModule,
  MatButtonToggleModule,
];

@NgModule({
  imports: MaterialModules,
  exports: MaterialModules,
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pl-PL' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    // { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }
  ]
})
export class MaterialDesignModule {
}
